import { useState, useEffect } from 'react';
import OrderScreen from '../components/OrderScreen';
import LoginScreen from '../components/LoginScreen';
import { useRouter } from 'next/router';

export default function Home() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('organizationCode');
    localStorage.removeItem('organizationId');
    localStorage.removeItem('completedItems');
    localStorage.removeItem('adminCode');
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  return (
    <>
      {isAuthenticated ? (
        <OrderScreen onLogout={handleLogout} />
      ) : (
        <LoginScreen onLogin={handleLogin} />
      )}
    </>
  );
}